/*
 *
 * Alerts constants
 *
 */
export const SET_SUBMIT = "app/usePrevent/SET_SUBMIT";
export const SET_SUBMIT_SUCCESS = "app/usePrevent/SET_SUBMIT_SUCCESS";
export const SET_SUBMIT_FAILURE = "app/usePrevent/SET_SUBMIT_FAILURE";
